<template>
	<div>
		<v-row>
			<v-col md="12" class="text-right">
				<v-btn color="primary" @click.prevent="agregarEnfermedad(null)"
					><v-icon>add</v-icon> Enfermedad/Padecimiento</v-btn
				>
			</v-col>
		</v-row>
		<v-row :align="'stretch'">
			<v-col v-for="(ant, i) in valor.Antecedentes" cols="3" :key="i">
				<v-card flat color="#f4f4f4" min-height="100%">
					<v-container>
						<v-row dense>
							<v-col>
								<div class="v-title">
									{{
										ant.Padecimiento.CampoAbierto
											? ant.Nombre
											: ant.Padecimiento.Nombre
									}}
								</div>
							</v-col>
							<v-col md="1">
								<v-icon
									color="red"
									@click="quitarEnfermedad(ant)"
									>close</v-icon
								>
							</v-col>
						</v-row>
						<v-row dense :align="'start'">
							<v-col md="auto" class="font-weight-medium">
								Tiempo Evolución:
							</v-col>
							<v-col md="auto">
								{{ ant.Tiempo }}
							</v-col>
						</v-row>
					</v-container>
				</v-card>
			</v-col>
		</v-row>
		<v-row v-if="!valor.Antecedentes.length"
			><v-col>
				<v-alert color="blue-grey white--text"
					>No se han agregado enfermedades</v-alert
				>
			</v-col></v-row
		>
		<v-row dense>
			<v-spacer></v-spacer>
			<v-btn
				class="mt-2"
				color="primary"
				@click.prevent="agregarFarmaco(ant)"
				><v-icon>add</v-icon> Fármaco</v-btn
			>
		</v-row>
		<v-row v-if="!valor.Farmacos.length"
			><v-col>
				<v-alert color="blue-grey white--text"
					>No se han agregado fármacos</v-alert
				>
			</v-col></v-row
		>
		<v-row :align="'stretch'">
			<v-col v-for="(farmaco, i) in valor.Farmacos" cols="3" :key="i">
				<v-card color="#f4f4f4" flat
					><v-card-text>
						<v-row dense>
							<v-col class="v-title">
								{{ farmaco.Farmaco }}
							</v-col>
							<v-col md="1">
								<v-icon
									color="red"
									@click="quitarFarmaco(farmaco)"
									>close</v-icon
								>
							</v-col>
						</v-row>
						<v-row dense>
							<v-col md="auto" class="font-weight-medium">
								Dosis:
							</v-col>
							<v-col md="auto">
								{{ farmaco.Dosis }}
							</v-col>
						</v-row>
						<v-row dense>
							<v-col class="font-weight-medium">
								Interacción fármaco - nutrimento:
							</v-col>
						</v-row>
						<v-row dense>
							<v-col>
								{{ farmaco.Nutrimiento }}
							</v-col>
						</v-row>
					</v-card-text></v-card
				>
			</v-col>
		</v-row>
		<v-form ref="formActual">
			<div class="pa-4">
				<v-layout row>
					<v-flex xs12 md3>
						Presentación de Cetolán:
					</v-flex>
					<v-flex xs12 md4>
						<v-select
							:rules="[
								!!valor.PresentacionCetolan || 'Campo Requerido'
							]"
							required
							class="ma-0 pa-0"
							hide-details="auto"
							:label="'Seleccione Presentación'"
							v-model="valor.PresentacionCetolan"
							return-object
							item-text="Descripcion"
							:items="catalogos.PresentacionesCetolan"
						></v-select>
					</v-flex>
				</v-layout>
				<v-row :justify="'start'">
					<v-col md="3">
						Dosis:
					</v-col>
					<v-col md="4">
						<v-text-field
							:rules="[!!valor.Dosis || 'Campo Requerido']"
							class="ma-0 pa-0"
							hide-details="auto"
							label="Dosis"
							v-model="valor.Dosis"
						></v-text-field>
					</v-col>
				</v-row>
			</div>
			<v-row :justify="'start'" v-if="!esVisita">
				<v-col>
					<v-simple-table class="no-bordes">
						<tbody>
							<template v-for="(h, i) in valor.Historia">
								<tr :key="i">
									<td>{{ h.Nombre }}</td>
									<td>
										<v-radio-group
											class="ma-3"
											hide-details="auto"
											row
											mandatory
											v-model="h.Presencia"
										>
											<v-radio
												label="Sí"
												:value="true"
											></v-radio>
											<v-radio
												label="No"
												:value="false"
											></v-radio>
										</v-radio-group>
									</td>
									<td>
										<v-text-field
											:rules="[
												!h.Presencia ||
													!!h.Especifique ||
													'Campo requerido'
											]"
											hide-details="auto"
											label="Especifique"
											v-model="h.Especifique"
											:disabled="!h.Presencia"
										></v-text-field>
									</td>
								</tr>
							</template>
						</tbody>
					</v-simple-table>
				</v-col>
			</v-row>
		</v-form>
		<v-layout row class="mt-3" v-if="!esVisita">
			<v-flex xs6>
				<v-btn color="primary" @click.prevent="anterior">
					<v-icon>arrow_back_ios</v-icon> ANTERIOR
				</v-btn>
			</v-flex>
			<v-flex xs6 class="text-right">
				<v-btn color="primary" @click.prevent="guardar">
					<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
				</v-btn>
			</v-flex>
		</v-layout>
		<v-dialog v-model="ant_nuevo" width="500px" persistent>
			<v-card>
				<v-card-title class="text-h5 primary--text">
					Añadir Enfermedad
					<v-spacer></v-spacer>
					<v-btn icon @click.native="ant_nuevo = false">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-form
						ref="formNuevoPadecimiento"
						@submit.prevent="crear_nueva"
					>
						<v-layout column>
							<v-select
								required
								:rules="[
									!!nueva.Padecimiento || 'Campo requerido'
								]"
								v-model="nueva.Padecimiento"
								label="Enfermedad/Padecimiento"
								item-text="Nombre"
								return-object
								:items="padecimientosDisponibles"
							></v-select>
							<v-text-field
								v-if="
									nueva.Padecimiento &&
										nueva.Padecimiento.CampoAbierto
								"
								required
								:rules="[!!nueva.Nombre || 'Campo requerido']"
								v-model="nueva.Nombre"
								label="Especifique Enfermedad/Padecimiento"
							></v-text-field>
							<v-text-field
								required
								:rules="[!!nueva.Tiempo || 'Campo requerido']"
								v-model="nueva.Tiempo"
								label="Tiempo Evolución"
							></v-text-field>
							<v-btn type="submit" color="primary">Guardar</v-btn>
						</v-layout>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog v-model="mostrarNuevoFarmaco" width="500px" persistent>
			<v-card>
				<v-card-title class="text-h5 primary--text">
					Añadir Fármaco
					<v-spacer></v-spacer>
					<v-btn icon @click.native="mostrarNuevoFarmaco = false">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-form
						ref="formAgregarFarmaco"
						@submit.prevent="guardarFarmaco"
					>
						<v-layout column>
							<v-text-field
								required
								:rules="[
									!!nuevoFarmaco.Farmaco || 'Campo requerido'
								]"
								v-model="nuevoFarmaco.Farmaco"
								label="Fármaco"
							></v-text-field>
							<v-text-field
								required
								:rules="[
									!!nuevoFarmaco.Dosis || 'Campo requerido'
								]"
								v-model="nuevoFarmaco.Dosis"
								label="Dosis"
							></v-text-field>
							<v-text-field
								required
								:rules="[
									!!nuevoFarmaco.Nutrimiento ||
										'Campo requerido'
								]"
								v-model="nuevoFarmaco.Nutrimiento"
								label="Interacción fármaco nutrimiento"
							></v-text-field>
							<v-btn type="submit" color="primary">Guardar</v-btn>
						</v-layout>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import ServicioCatalogos from "../../../services/catalogos";
import ServicioHistorialClinico from "../../../services/historialClinico";
import { Catalogos } from "../../../services/catalogos";
export default {
	props: ["datos", "esVisita", "validateForm"],
	name: "antPerPatFar",
	data() {
		return {
			catalogos: {
				Padecimientos: [
					{
						Nombre: "N18. Enfermedad Renal Crónica",
						PadecimientoID: 1,
						CampoAbierto: false
					},
					{
						Nombre: "E11. Diabetes mellitus tipo II",
						PadecimientoID: 2,
						CampoAbierto: false
					},
					{
						Nombre: "I10. Hipertensión arterial",
						PadecimientoID: 3,
						CampoAbierto: false
					},
					{
						Nombre: "N00. Síndrome nefrítico agudo",
						PadecimientoID: 4,
						CampoAbierto: false
					},
					{
						Nombre: "N04. Síndrome nefrótico",
						PadecimientoID: 5,
						CampoAbierto: false
					},
					{
						Nombre: "Enfermedad autoinmune",
						PadecimientoID: 6,
						CampoAbierto: true
					},
					{
						Nombre: "Desconocido o no definido",
						PadecimientoID: 7,
						CampoAbierto: true
					},
					{ Nombre: "Otro", PadecimientoID: 8, CampoAbierto: true }
				],
				PresentacionesCetolan: []
			},
			valor: {
				Antecedentes: [],
				Presentacion: "",
				Dosis: "",
				Farmacos: [],
				Historia: [
					{
						PadecimientoHistoriaID: 1,
						Nombre: "Cirugías",
						Presencia: false,
						Especifique: ""
					},
					{
						PadecimientoHistoriaID: 2,
						Nombre: "Hospitalizaciones",
						Presencia: false,
						Especifique: ""
					},
					{
						PadecimientoHistoriaID: 3,
						Nombre: "Transfusiones",
						Presencia: false,
						Especifique: ""
					},
					{
						PadecimientoHistoriaID: 4,
						Nombre: "Fracturas",
						Presencia: false,
						Especifique: ""
					},
					{
						PadecimientoHistoriaID: 5,
						Nombre: "Ser. Viral (Vih, Hepatitis)",
						Presencia: false,
						Especifique: ""
					},
					{
						PadecimientoHistoriaID: 6,
						Nombre: "Alergias",
						Presencia: false,
						Especifique: ""
					},
					{
						PadecimientoHistoriaID: 7,
						Nombre: "Prótesis Metálicos, Marcapasos U Otros",
						Presencia: false,
						Especifique: ""
					}
				]
			},
			presentacion_items: ["Tabletas 630 mg", "Sobres III", "Sobres IV"],
			ant_nuevo: false,
			nueva: {
				Padecimiento: "",
				Nombre: "",
				Tiempo: ""
			},
			nuevoFarmaco: {
				Farmaco: "",
				Dosis: "",
				Nutrimiento: ""
			},
			editar_ant: false,
			padecimientoSeleccionado: null,
			mostrarNuevoFarmaco: false
		};
	},
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		},
		padecimientosDisponibles() {
			return this.catalogos.Padecimientos.filter(
				p =>
					!this.valor.Antecedentes.some(
						a => a.Padecimiento.PadecimientoID === p.PadecimientoID
					)
			);
		}
	},
	methods: {
		quitarFarmaco(farmaco) {
			this.valor.Farmacos.splice(this.valor.Farmacos.indexOf(farmaco), 1);
		},
		quitarEnfermedad(enf) {
			this.valor.Antecedentes.splice(
				this.valor.Antecedentes.indexOf(enf),
				1
			);
		},
		agregarEnfermedad() {
			this.ant_nuevo = true;
			if (this.$refs.formNuevoPadecimiento)
				this.$refs.formNuevoPadecimiento.reset();
		},
		agregarFarmaco() {
			this.mostrarNuevoFarmaco = true;
			if (this.$refs.formAgregarFarmaco)
				this.$refs.formAgregarFarmaco.reset();
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioHistorialClinico.guardarAntecedentesPatologicos(
					this.historiaCliniciaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.siguiente();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene los campos requeridos.";
			}
		},
		guardarFarmaco() {
			if (this.$refs.formAgregarFarmaco.validate()) {
				this.valor.Farmacos.push(this.nuevoFarmaco);
				this.mostrarNuevoFarmaco = false;
				this.nuevoFarmaco = {
					Farmaco: "",
					Dosis: "",
					Nutrimiento: ""
				};
			}
		},
		crear_nueva() {
			if (this.$refs.formNuevoPadecimiento.validate()) {
				const nueva = {
					Padecimiento: this.nueva.Padecimiento,
					Nombre: this.nueva.Nombre,
					Tiempo: this.nueva.Tiempo
				};
				this.valor.Antecedentes.push(nueva);
				this.ant_nuevo = false;
				this.nueva = {
					Padecimiento: null,
					Nombre: "",
					Tiempo: ""
				};
			}
		},
		siguiente() {
			this.$emit("siguiente");
		},
		anterior() {
			this.$emit("anterior");
		},
		async obtenerCatalogos() {
			let res = await ServicioCatalogos.getCatalogo(
				Catalogos.HistorialClinico_PresentacionCetolan
			);
			this.catalogos.PresentacionesCetolan = res.data.data.Table0;
		}
	},
	async mounted() {
		await this.obtenerCatalogos();
	},
	watch: {
		datos() {
			if (this.datos) {
				this.valor =
					typeof this.datos === "string"
						? JSON.parse(this.datos)
						: this.datos;
			}
		},
		validateForm() {
			if (this.validateForm) {
				if (!this.$refs.formActual.validate()) {
					this.$emit("valorCambiado", null);
				} else {
					this.$emit("valorCambiado", this.valor);
				}
			}
		}
	}
};
</script>
<style>
.v-title {
	padding: 2px;
	color: #1c62ad;
	font-size: 24px;
	font-weight: 400;
}
</style>
